export const toggleSearch = isSearchActive => {
  return {
    type: 'TOGGLE_SEARCH',
    isSearchActive: isSearchActive
  }
}
